import { useSyncExternalStore } from 'react'
import { CollectionState } from '../collection-state'

export function useSelectedRows (state: CollectionState) {
  return useSyncExternalStore(
    callback => state.addEventListener('selectedRowsChanged', callback),
    () => state.selectedRows
  )
}
